import { ReactComponent as SprintHigh } from 'assets/icons/sprint_high.svg'
import { ReactComponent as SprintLow } from 'assets/icons/sprint_low.svg'
import { ReactComponent as SprintMedium } from 'assets/icons/sprint_medium.svg'
import { Task } from 'components/keyTasks/KeyTasks'

export const CreateBubbles: Task[] = [
  {
    title: 'Confirm the path forward',
    description:
      'If you have decided to use a sprint-based approach, start planning for your creative sprint. Move forward based on whether you need to develop a new platform, a new BBEI, or a refreshed set of experiences on the same idea.',
    backgroundColor: '#FEF1DC',
  },
  {
    title: 'Develop creative strategy',
    description:
      'Plan your strategy and validate concepts in partnership with your Human Insights team. Build data-driven, nuanced creative based on audience planning best practice.',
    backgroundColor: '#FEF1DC',
  },
  {
    title: 'Design brave and boundless ideas',
    description: 'Ideate on experiences and diverge and converge on the creative explosion of ideas.',
    backgroundColor: '#FEF1DC',
  },
  {
    title: 'Validate idea with consumers',
    description:
      'Partner with Human Insights to choose the right type of testing to answer your questions and gain insights. When testing creativity, remember to look at product-centric metrics such as product recognition, understanding, and perception to maximize impact.',
    backgroundColor: '#FEF1DC',
  },
  {
    title: 'Sign off creative strategy, BBEI, & experiences with your sponsor',
    description: 'Build a high-level plan and long term roadmap. Populate a dynamic ideas bank.',
    backgroundColor: '#FEF1DC',
  },
  {
    title: 'Kick off design work ',
    backgroundColor: '#FEF1DC',
  },
]

export const CreateKeyInputs = [
  { text: 'One Brief' },
  { text: 'E2E Strategy including audience, moments, & occasions: Audience Matrix' },
]
export const CreateKeyOutputs = [
  { text: 'BEI and proof of concepts (PoCs)' },
  { text: 'Roadmap with ideas to scale' },
  { text: 'Ideas Bank' },
  { text: 'XP Architecture' },
  {
    text: 'Reflections and improvements on ways of working',
    link: 'https://app.mural.co/t/marketing6265/m/marketing6265/1747976237864/f1cf546811959a5c0c18fc38ec66fbdef1cdaf45',
  },
]

export const CreateCards = [
  {
    title: 'The core team decides how to tackle Create',
    description:
      'The core team decides whether a sprint-based approach should be deployed and determines the best format or methodology to use.',
  },
  {
    title: 'Sprinting is not a last-minute solution',
    description:
      'It is part of a longer-term planning scope, so allow proper time to prepare. Most of the work comes before the creative co-creation.',
  },
  {
    title: 'Diversity = creativity',
    description:
      'Invite internal teams, WPP, open-source talent such as media tech partners. Leverage AI tools for prototyping and design thinking to ensure human-centricity.',
  },
  {
    title: 'Focus on makers and over-index on creatives',
    description: 'Bring in creators and makers who can get hands-on, not just those who want to be looped in.',
  },
  {
    title: 'Must-haves vs. nice-to-haves',
    description:
      'Sprinting is modular, but should be time-bound, consumer-centric, and grounded in co-creation. Decision-making should be clear.',
  },
  {
    title: 'A bridge to OUs and markets',
    description:
      'The participating OU representatives take this deep understanding of the work to markets and lead "Shape sessions" to ensure seamless localization.',
  },
]

export const SprintCards = [
  {
    icon: <SprintLow />,
    size: 'Low',
    topBarClass: 'w-1/3',
    color: '#CDEDA6',
    link: false,
    bullets: [
      {
        title: 'PURPOSE',
        description: 'Big idea exists but needs new execution or modifications to existing work (i.e. new experience).',
      },
      {
        title: 'DESCRIPTION',
        description:
          'A sprint designed to crack the best experience execution possible, for a specific brand and need.',
      },
      {
        title: 'DECISION MAKER',
        description: 'OU - Brand Lead',
      },
    ],
  },
  {
    icon: <SprintMedium />,
    size: 'Medium',
    topBarClass: 'w-1/2',
    color: '#FEDEA8',
    link: 'https://facade-api-tccc-prod-coke.playground.coke.com/api/file-manager/v1/tenants/571f9aa5-bb8b-4f9f-8835-23e74b64e050/files/c3322f45-4c0c-4628-8820-896e3b8ea2a5/public-download',
    bullets: [
      {
        title: 'PURPOSE',
        description: 'Persistent Platform exists, but new idea development is needed (i.e. new BBEI).',
      },
      {
        title: 'DESCRIPTION',
        description:
          'A sprint designed to crack the biggest, bravest, and most boundless idea possible for a specific brand.',
      },
      {
        title: 'DECISION MAKER',
        description: 'Global / OU - Brand Lead',
      },
    ],
  },
  {
    icon: <SprintHigh />,
    size: 'High',
    topBarClass: 'w-full',
    color: '#FFDAD3',
    link: 'https://facade-api-tccc-prod-coke.playground.coke.com/api/file-manager/v1/tenants/571f9aa5-bb8b-4f9f-8835-23e74b64e050/files/b374fbbf-806f-4aff-ae72-b3de8010e215/public-download',
    bullets: [
      {
        title: 'PURPOSE',
        description:
          'Significant strategic challenges for the organization or a whole new direction for the brand (i.e. new Persistent Platform).',
      },
      {
        title: 'DESCRIPTION',
        description: 'A sprint designed to crack enterprise-level strategic problems for a category and its brands.',
      },
      {
        title: 'DECISION MAKER',
        description: 'Global Category - President',
      },
    ],
  },
]
